/** ----------------------------------------
    Quickscan routes
---------------------------------------- */

const routes = [
    {
        path: '/quickscan',
        redirect: '/quickscan/0',
        component: () => import('@view/templates/Quickscan.vue'),
        children: [
            {
                path: ':step',
                name: 'quickscan.step',
                component: () => import('@view/templates/QuickscanStep.vue'),
            },
        ],
    },
],
 
/** ----------------------------------------
    Export Modules
---------------------------------------- */

export default routes;